import React, { Component, Fragment } from "react";
import { LanguageConsumer, Translate } from '../../../contexts/LanguageContext';
import { Loading, BreadCrumb, Card, UserAccounts, Validator, ErrorMessage } from "../../../components";
import { TransferOptionUrl, Rules, Currencies, PaymentConfirm } from "../../../components/Payment";
import { PaymentService } from "../../../services/PaymentService";
import { TransferOptionService } from "../../../services/TransferOptionService";
import { DepositService } from "../../../services/DepositService";

export class CommunityBank extends Component {

    constructor(props) {
        super(props)

        this.Refs = React.createRef();

        this.state = {
            loading: true,
            confirm: false,
            paymentOptions: {
                acceptedCurrencies: [],
                description: "",
                rules: [],
                title: ""
            },
            login: 0,
            bankName: "",
            swiftCode: "",
            amount: 0,
            activeAmountId: 0,
            currency: "",
            // CB
            accessToken: "",
            availableBanks: [],
            activeAmount: [],
            // ERROR
            validation: {
                error: false,
                message: ""
            }
        }
    }
    componentWillMount() {

        TransferOptionService.Deposit.OptionPage(TransferOptionUrl()).then((response) => {
            this.setState({
                paymentOptions: response,
                currency: response.acceptedCurrencies[0],
                error: false
            }, () => {
                PaymentService.Deposit.CommunityBank.BankList().then((response) => {
                    if (response !== false) {
                        this.setState({
                            availableBanks: response.availableBanks,
                            accessToken: response.accessToken,
                            loading: false
                        });
                    } else {
                        this.setState({
                            loading: false
                        });
                    }
                });
            })
        });
    }
    changeAccount(userAccount) {
        this.setState({
            login: userAccount.active
        });
    }

    onChangeBank(e) {

        let value = e.target.value,
            title = e.target.options[e.target.selectedIndex].text;

        if (value !== "-1") {

            this.setState({
                loading: true,
                bankName: title,
                swiftCode: value
            }, () => {

                PaymentService.Deposit.CommunityBank.AmountList({
                    swiftCode: value,
                    accessToken: this.state.accessToken
                }).then((response) => {
                    this.setState({
                        activeAmount: response.activeAmount,
                        loading: false
                    });
                });

            });

        } else {
            this.setState({
                activeAmount: []
            });
        }

    }
    onChangeAmount(e) {

        let value = e.target.value,
            title = e.target.options[e.target.selectedIndex].text;

        if (value !== "-1") {
            this.setState({
                amount: title,
                activeAmountId: value
            });
        }
    }
    onChangeCurrency(e) {
        this.setState({ currency: e.target.value });
    }
    onToggleDeposit() {
        if (this.isValid())
            this.setState(prevState => ({
                confirm: !prevState.confirm
            }));
    }
    isValid() {


        if (!this.state.confirm) {

            let error = Validator.Valid({
                bankCode: this.state.swiftCode,
                amount: this.state.amount
            }, this.Refs);

            this.setState({
                validation: error
            });

            return !error.error;
        }

        return true;
    }
    onConfirmDeposit() {

        this.setState({ loading: true }, () => {

            DepositService.CommunityBank({
                login: this.state.login,
                amount: this.state.amount,
                currency: this.state.currency,
                bankCode: this.state.swiftCode,
                activeAmountId: this.state.activeAmountId
            }).then((response) => {

                if (response.error) {
                    this.setState({
                        validation: {
                            error: response.error,
                            message: response.message
                        },
                        loading: false
                    });
                }
            });
        });

    }
    render() {
        let availableBanks = this.state.availableBanks.map((item) => (
            <option key={item.swiftCode} value={item.swiftCode}>{item.bankName}</option>
        ));
        let activeAmount = this.state.activeAmount.map((item) => (
            <option key={item.activeAmountId} value={item.activeAmountId}>{item.amount}</option>
        ));
        return (
            <LanguageConsumer>
                {() => (
                    <Fragment>
                        <Loading Show={this.state.loading} Title={Translate("Loading Content")} />
                        <BreadCrumb Title={this.state.paymentOptions.title} Name={this.state.paymentOptions.title} SubTitle={Translate("Deposit")} SubUrl="/deposit" />
                        <Card Title={this.state.paymentOptions.title} Description={this.state.paymentOptions.description} Logo={this.state.paymentOptions.logo}>
                            <div className="row">
                                <div className="col-md-12">
                                    <Rules Items={this.state.paymentOptions.rules} />
                                </div>
                                <ErrorMessage Validation={this.state.validation} />
                                {!this.state.confirm ?
                                    <div className="col-md-12">
                                        <form className="form-horizontal" name="depositForm" ref={this.Refs}>
                                            <h4 className="mt-0 header-title m-b-20 mt-4 text-dark"><i className="fas fa-file-invoice"></i>{Translate("&nbsp; Payment Form")}</h4>
                                            <div className="form-group row ml-3">
                                                <label htmlFor="example-text-input" className="col-sm-2 col-form-label">{Translate("Account")}</label>
                                                <div className="col-sm-5">
                                                    <UserAccounts List className="bg-dark" Change={(e, userAccount) => this.changeAccount(userAccount)} Status="deposit"/>
                                                </div>
                                            </div>
                                            <div className="form-group row ml-3">
                                                <label htmlFor="bank" className="col-sm-2 col-form-label">{Translate("Bank")}</label>
                                                <div className="col-sm-5">
                                                    <select className="form-control" id="bankCode" onChange={(e) => this.onChangeBank(e)}>
                                                        <option value="-1">{Translate("Select Bank")}</option>
                                                        {availableBanks}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="form-group row ml-3">
                                                <label htmlFor="amount" className="col-sm-2 col-form-label">{Translate("Amount")}</label>
                                                <div className="col-sm-5">
                                                    <select className="form-control disabled" id="amount" onChange={(e) => this.onChangeAmount(e)}>
                                                        <option value="-1">{Translate("Select Amount")}</option>
                                                        {activeAmount}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="form-group row ml-3">
                                                <label htmlFor="currency" className="col-sm-2 col-form-label">{Translate("Currency")}</label>
                                                <div className="col-sm-5">
                                                    <Currencies Items={this.state.paymentOptions.acceptedCurrencies} onChange={(e) => this.onChangeCurrency(e)} />
                                                </div>
                                            </div>
                                            <div className="form-group row ml-3">
                                                <label htmlFor="example-text-input" className="col-sm-2 col-form-label"></label>
                                                <div className="col-sm-5">
                                                    <button type="button" className="btn btn-lg btn-success" onClick={(e) => this.onToggleDeposit()}>{Translate("Create a Deposit Request")}</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    :
                                    <PaymentConfirm Form={[
                                        {
                                            title: Translate("Account"),
                                            value: this.state.login
                                        },
                                        {
                                            title: Translate("Bank"),
                                            value: this.state.bankName
                                        },
                                        {
                                            title: Translate("Amount"),
                                            value: this.state.amount.format('C') + " " + this.state.currency
                                        }
                                    ]} Cancel={(e) => this.onToggleDeposit()} Confirm={(e) => this.onConfirmDeposit()} />
                                }
                            </div>

                        </Card>
                    </Fragment>
                )}
            </LanguageConsumer>
        )
    }

}
